import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

import { notifyUser } from "../utils/notifyUser";

export default function CreateUser() {
    const [form, setForm] = useState({
        first_name: "",
        last_name: "",
        email: "",
        role: "",
    });

    const [error] = useState("");
    const navigate = useNavigate();

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const handleCreate = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BACKEND_URL}/api/auth/admin/create-user`,
                form,
                { withCredentials: true },
            );
            console.log("User created:", response.data);
            notifyUser(null, "success", "User created successfully!", "toast", null, null, null, null, null, false, false, "top-center");
            navigate("/Users");
        } catch(err) {
            if(err.response && err.response.data && err.response.data.error) {
                notifyUser(null, "error", err.response.data.error, "toast", null, null, null, null, null, false, false, "top-center");
            } else {
                notifyUser(null, "error", "User already exists or an error occurred", "toast", null, null, null, null, null, false, false, "top-center");
            }
        }
    };

    return (
        <div className="flex justify-center items-center h-screen bg-gray-100 font-sans">
            <div className="w-full max-w-lg p-8 bg-white shadow-xl rounded-2xl relative">
                <div className="mb-6">
                    <h2 className="text-2xl font-extrabold text-navy text-center">
                        CREATE NEW USER
                    </h2>
                </div>

                {error && (
                    <p className="text-red-500 text-sm text-center mb-4">
                        {error}
                    </p>
                )}

                <form onSubmit={handleCreate} className="space-y-6">
                    <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
                        <input
                            type="text"
                            name="first_name"
                            placeholder="First Name"
                            value={form.first_name}
                            onChange={handleChange}
                            className="w-full p-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-navy transition-all duration-200"
                            required
                        />
                        <input
                            type="text"
                            name="last_name"
                            placeholder="Last Name"
                            value={form.last_name}
                            onChange={handleChange}
                            className="w-full p-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-navy transition-all duration-200"
                            required
                        />
                    </div>

                    <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={form.email}
                        onChange={handleChange}
                        className="w-full p-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-navy transition-all duration-200"
                        required
                    />

                    <div className="relative">
                        <select
                            name="role"
                            className="w-full p-3 border-2 border-gray-300 rounded-lg appearance-none focus:outline-none focus:border-navy transition-all duration-200 bg-white"
                            onChange={handleChange}
                            value={form.role}
                            required
                        >
                            <option value="" disabled>
                                Select Role
                            </option>
                            <option value="admin">Admin</option>
                            <option value="investor">Investor</option>
                            <option value="entrepreneur">Entrepreneur</option>
                        </select>
                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-gray-700">
                            <i
                                className="fa fa-chevron-down text-base"
                                aria-hidden="true"
                            ></i>
                        </div>
                    </div>

                    <div className="flex items-center justify-between mt-8">
                        <button
                            type="button"
                            aria-label="Back"
                            className="flex items-center gap-2 text-navy hover:text-navy-2 font-semibold text-base px-3 py-2 rounded-lg transition-colors duration-200 border border-[#C2D7E2] bg-[#F5FAFC]"
                            onClick={() => navigate("/Users")}
                        >
                            <i
                                className="fa fa-arrow-left"
                                aria-hidden="true"
                            ></i>
                            Back
                        </button>
                        <button
                            type="submit"
                            className="bg-navy text-white font-bold py-3 px-8 rounded-lg hover:bg-navy-2 transition-colors duration-200 text-lg shadow-md"
                        >
                            Create User
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
